interface DiffImplementation {
  version: 'v1' | 'v2'
  virtualized: boolean
}

export function getCurrentDiffImplementation(virtualizeDiffEntries: boolean): DiffImplementation {
  return {
    version: 'v2',
    virtualized: virtualizeDiffEntries,
  }
}
